import { gsap } from 'gsap'
import { elementInView, scrollFunction } from '../utils/_scroll-handler'

export default function GraphSlider () {
  const CONTAINERS = document.querySelectorAll('.mtt-graph-slider:not(.mtt-graph-slider--type-no-graph) .mtt-graph-slider__items-wrap')

  if (CONTAINERS.length > 0) {
    for (let i = 0; i < CONTAINERS.length; i++) {

      const CONTAINER = CONTAINERS[i]
      let playing = false

      gsap.config({
        force3D: true
      })

      const anim = gsap.to(CONTAINER, {
        duration: 60,
        ease: 'none',
        repeat: -1,
        x: '-100%',
        paused: true
      })

      if (elementInView(CONTAINER)) {
        anim.play()
        playing = true
      }

      // Stop animation when no longer in view
      scrollFunction(() => {
        if (elementInView(CONTAINER) && !playing) {
          anim.play()
          playing = true
        } else if (!elementInView(CONTAINER) && playing) {
          anim.pause()
          playing = false
        }
      })
    }
  }
}